/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
  ==========================================================================================*/
import axios from 'axios'
import { baseApiUrl, renewLocalStorage, avatarPhoto } from "../global";
const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // User/Account

  async updateUserInfo({ commit }, user) {
    axios.defaults.headers.common['Authorization'] = `bearer ${user.token}`
    commit('SET_USER_INFO', user)
    renewLocalStorage(user.token)
  },

  async createUserInfo({ commit }, user) {
    commit('SET_USER_INFO', user)
  },

  // Webmais Synchronize

  async fetchLastUpdates({ commit }, payload) {
    const haveLoading = payload && payload.loading
    try {
      if (haveLoading) payload.loading()
      const response = await axios.get(`${baseApiUrl}/last-updates`);
      await commit('SET_LAST_UPDATES', response.data)
    } catch (error) {
      console.log(error)
    } finally {
      if (haveLoading) payload.loading.close()
    }
  },

  async fetchSynchronizeWebmais({ commit }, payload) {
    const haveLoading = payload && payload.loading
    try {
      if (haveLoading) payload.loading({text: 'Essa tarefa pode demorar até 1 minuto.'})
      const response = await axios.post(`${baseApiUrl}/webmais/export-` + payload.type);
      await commit('SET_LAST_UPDATES', response.data)
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel sincronizar",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    } finally {
      if (haveLoading) payload.loading.close()
    }
  },

  // Products

  async fetchProductsItems({ commit }, payload) {
    const haveLoading = payload && payload.loading
    try {
      if (haveLoading) payload.loading()
      const response = await axios.post(`${baseApiUrl}/product/getAllProducts`);
      await commit('SET_PRODUCTS', response.data)
    } catch (error) {
      console.log(error)
    } finally {
      if (haveLoading) payload.loading.close()
    }
  },

  async updateProduct({ commit }, payload) {
    try {
      const response = await axios.post(`${baseApiUrl}/product/updateProduct`, payload.formData)
      payload.product = response.data
      await commit('UPDATE_PRODUCT', payload.product)
      payload.notify({
        title: "Sucesso",
        text: "Produto editado",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },


  // Orders
  async fetchOrdersItems({ commit }, payload) {
    const haveLoading = payload && payload.loading
    try {
      if (haveLoading) payload.loading()
      const response = await axios.post(`${baseApiUrl}/order/getAllOrders`);
      await commit('SET_ORDERS', response.data)
    } catch (error) {
      console.log(error)
    } finally {
      if (haveLoading) payload.loading.close()
    }
  },

  // Customers
  async fetchCustomersItems({ commit }, payload = {}) {
    const haveLoading = payload && payload.loading
    try {
      if (haveLoading) payload.loading()
      const params = payload.params
      const response = await axios.get(`${baseApiUrl}/customers`, { params });
      await commit('SET_CUSTOMERS', response.data)
    } catch (error) {
      console.log(error)
    } finally {
      if (haveLoading) payload.loading.close()
    }
  },

  // Carriers
  async fetchCarriersItems({ commit }, payload) {
    const haveLoading = payload && payload.loading
    try {
      if (haveLoading) payload.loading()
      const response = await axios.get(`${baseApiUrl}/carrier`);
      await commit('SET_CARRIERS', response.data)
    } catch (error) {
      console.log(error)
    } finally {
      if (haveLoading) payload.loading.close()
    }
  },

  async addCarrier({ commit }, payload) {
    try {
      const response = await axios.post(`${baseApiUrl}/carrier`, payload.formData)
      await commit('ADD_CARRIER', response.data)
      payload.notify({
        title: "Sucesso",
        text: "Transportadora adicionada",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      payload.notify({
        title: "Erro",
        text: "Não foi possivel adicionar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },

  async updateCarrier({ commit }, payload) {
    try {
      const response = await axios.put(`${baseApiUrl}/carrier/${payload.idTransportadora}`, payload.formData)
      await commit('UPDATE_CARRIER', response.data)
      payload.notify({
        title: "Sucesso",
        text: "Transportadora editada",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      payload.notify({
        title: "Erro",
        text: "Não foi possivel adicionar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },

  // Importations
  async fetchImportationsItems({ commit }, payload) {
    const haveLoading = payload && payload.loading
    try {
      if (haveLoading) payload.loading()
      const response = await axios.get(`${baseApiUrl}/importation`);
      await commit('SET_IMPORTATIONS', response.data)
    } catch (error) {
      console.log(error)
    } finally {
      if (haveLoading) payload.loading.close()
    }
  },
}

export default actions